export type FilterKey = 'all' | 'new' | 'converted' | 'missed';

interface ChipOption {
  key:   FilterKey;
  label: string;
}

interface ChipFilterProps {
  options:  ChipOption[];
  active:   FilterKey;
  onChange: (key: FilterKey) => void;
}

export function ChipFilter({ options, active, onChange }: ChipFilterProps) {
  return (
    <div className="chip-filter" role="group" aria-label="Filter klicev">
      {options.map(({ key, label }) => (
        <button
          key={key}
          className={`chip${active === key ? ' active' : ''}`}
          onClick={() => onChange(key)}
          aria-pressed={active === key}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
